<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.application')"
    resource="applications"
    :onFormSubmit="handleSubmit"
    :actionButtons="['show', 'edit']"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/applications.js';

@Component
export default class Application extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'wechat_application_appid_cont',
      'name_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      {
        key: 'wechat_application.appid',
        label: 'AppID',
        width: 150
      },
      'name',
      'logo',
      type === 'show' && 'share_desc',
      // type === 'show' && 'share_image',
      // type === 'show' && 'poster_image',
      type === 'show' && 'login_video',
      type === 'show' && {
        key: 'image_generate_options',
        renderCell: {
          component: 'list',
          props: {
            columns: [
              { prop: 'model', label: '模型' },
              { prop: 'batchCount', label: '生成张数' },
              { prop: 'guidanceScale', label: '引导强度' },
              { prop: 'negativePrompt', label: '负向描述' },
              { prop: 'steps', label: '迭代次数' },
            ]
          },
        },
      },
      'created_at',
      'updated_at'
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      {
        key: 'logo',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 150x150`,
          props: {
            cropper: {
              width: 150,
              height: 150
            }
          }
        }
      },
      {
        key: 'share_desc',
        renderCell: {
          hint: this.$t('hint.shareDescLengthHint'),
        }
      },
      // {
      //   key: 'share_image',
      //   renderCell: {
      //     hint: `${this.$t('suggestSize')}: 500x400`,
      //     props: {
      //       cropper: {
      //         width: 500,
      //         height: 400
      //       }
      //     }
      //   }
      // },
      // {
      //   key: 'poster_image',
      //   renderCell: {
      //     hint: `${this.$t('suggestSize')}: 600x509`,
      //     props: {
      //       cropper: {
      //         width: 600,
      //         height: 509
      //       }
      //     }
      //   }
      // },
      {
        key: 'login_video',
        renderCell: {
          component: 'upload',
          props: {
            accept: 'video/*',
            type: 'video',
            size: 5000
          }
        }
      },
      {
        key: 'image_generate_options',
        label: '图片生成选项',
        renderCell: {
          component: 'staticNestForm',
          props: {
            columns: [
              {
                prop: 'model',
                label: '模型',
                renderCell: {
                  component: 'input',
                  required: true,
                }
              },
              {
                prop: 'batchCount',
                label: '生成张数',
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    step: 1,
                    min: 1,
                    max: 16
                  }
                }
              },
              {
                prop: 'guidanceScale',
                label: '引导强度',
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    step: 1,
                    min: 1,
                    max: 30
                  }
                }
              },
              {
                prop: 'negativePrompt',
                label: '负向描述',
                renderCell: {
                  component: 'input',
                }
              },
              {
                prop: 'steps',
                label: '迭代次数',
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    step: 1,
                    min: 1,
                    max: 100
                  }
                }
              },
            ].filter(Boolean)
          }
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    const env = process.env.VUE_APP_ENV
    const wechat_application = row.wechat_application
    let canSubmitAudit = false
    let canRelease = false
    let canMockSubmitAudit = false
    let canMockRelease = false

    if (wechat_application) {
      if (wechat_application.trial_submition) {
        if (env === 'development') {
          canMockSubmitAudit = !wechat_application.audit_submition || (wechat_application.audit_submition.state !== 'pending' && wechat_application.audit_submition.state !== 'delay')
        } else {
          canSubmitAudit = !wechat_application.audit_submition || (wechat_application.audit_submition.state !== 'pending' && wechat_application.audit_submition.state !== 'delay')
        }
      }

      if (wechat_application.audit_submition) {
        if (env === 'development') {
          canMockRelease = wechat_application.audit_submition.state === 'success'
        } else {
          canRelease = wechat_application.audit_submition.state === 'success'
        }
      }
    }

    const handleSubmitAudit = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/submit_audit`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleMockSubmitAudit = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_submit_audit`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleRelease = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/release`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleMockRelease = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_release`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    //const handleBindWechat = async (isBinded) => {
    //  if (isBinded) {
    //    const { url } = await this.$request.get('wechat_third_party_platform/base/component_auth_url');
    //     window.location = url;
    //  } else {
    //    this.$router.push({ name: 'bind_exists_mini_program' });
    //  }
    //}

    const expiredAtForm = [
      {
        prop: 'expired_at',
        label: this.$t('application.expiredAt'),
        renderCell: {
          component: 'dateTimePicker',
        }
      }
    ]
    const handleSubmitExpiredAtForm = async (value) => {
      await this.$autoLoading(this.$request.put(`/applications/${row.id}/update_expired_at`, value));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'applications.edit', params: { id: row.id } }
        }
      },
      canSubmitAudit && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.submitAudit'),
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleSubmitAudit(row.wechat_application_id)
        }
      },
      canMockSubmitAudit && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.simulateSubmitAudit'),
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleMockSubmitAudit(row.wechat_application_id)
        }
      },
      canRelease && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.release'),
          type: 'primary',
          can: 'wtpp_applications.release'
        },
        on: {
          confirm: () => handleRelease(row.wechat_application_id)
        }
      },
      canMockRelease && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.simulateRelease'),
          type: 'primary',
          can: 'wtpp_applications.release'
        },
        on: {
          confirm: () => handleMockRelease(row.wechat_application_id)
        }
      },
      //{
      //  functional: true,
      //  render: () => {
      //    const isBinded = _.get(row, 'wechat_application.id');
      //    return <el-button type="primary" size="mini" onClick={() => handleBindWechat(isBinded)}>{ isBinded ? this.$t('application.actions.reauthorization') : this.$t('application.actions.bindMiniProgram') }</el-button>
      //  }
      //},
      {
        component: 'dialogFormButton',
        props: {
          label: this.$t('application.actions.updateExpiredAt'),
          columns: expiredAtForm,
          value: row,
          can: 'applications.update_expired_at',
          submitHandler: handleSubmitExpiredAtForm
        }
      }
    ].filter(Boolean);
  }

  async handleSubmit({ data, type, resource, namespace }) {
    if (type === 'new') {
      const response = await this.$request.post(`/${namespace}${resource}`, data);
      this.$message.success(this.$t('bean.createSuccess'));
      localStorage.setItem('currentRoleId', response.application_admin_users_role_id);
      this.$router.push({ name: 'home' });
      location.reload();
    } else {
      await this.$request.put(`/${namespace}${resource}/${data.id}`, data);
      this.$message.success(this.$t('bean.updateSuccess'));
      this.$router.push({ name: `${resource}.show`, params: { id: data.id } });
    }
  }
}

export const route = [
  {
    path: '/applications',
    name: 'applications.index',
    component: Application,
    props: {
      type: 'index',
    }
  },
  {
    path: '/applications/new',
    name: 'applications.new',
    component: Application,
    props: {
      type: 'new',
    }
  },
  {
    path: '/applications/:id',
    name: 'applications.show',
    component: Application,
    props: {
      type: 'show',
    }
  },
  {
    path: '/applications/:id/edit',
    name: 'applications.edit',
    component: Application,
    props: {
      type: 'edit'
    }
  }
]
</script>
